import { render, staticRenderFns } from "./ConfigPublicJobBoard.vue?vue&type=template&id=3d0fc787"
import script from "./ConfigPublicJobBoard.vue?vue&type=script&lang=js"
export * from "./ConfigPublicJobBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports